module.exports = "/images/smarty-thumb-1.svg?2218b05c08c83b44df9783b74b58b240";